const UploadRecord = ({ work_order }) => {

  
    

    return (
        <>


            {(work_order && work_order?.authorization_status == 1 && work_order?.status >= 1) &&
                <>
                    <div className="row mt-2 mx-0 sub-heading">
                        <div className="col py-1">

                            <div className=" px-3 py-2 fw-bold text-dark">Medical Record</div>

                        </div>
                        
                    </div>
                   
                        
                        {(work_order?.status >= 4) ?
                        <>
                            <div className="row px-0 py-2 gx-2 my-4 mx-4">
                                <div className="col-xl-12 col-lg-12 col-sm-12">
                                    <a className="btn btn-sm btn-sm btn-success ms-1" href={process.env.REACT_APP_WEB_SERVICES_URL + "/client/download-medical-record-file/" + work_order.work_order_id} target="_blank" >DOWNLOAD</a>
                                    </div>
                            </div>


{(work_order?.medical_record_optional_file_1 || work_order?.medical_record_optional_file_2) &&
<>
                                    <div class="row mt-2 mx-0 sub-heading pt-3 pb-2">
                                        <div className="col-12">
                                            <h6 className="fw-bold">Additional Records</h6>
                                        </div>
                                    </div>


                                    <div className="row px-0 py-2 gx-2 my-4 mx-4">
                                        {(work_order?.medical_record_optional_file_1) &&

                                            <div className="col-xl-6 col-lg-6 col-sm-12">
                                                <div className="input-group ">
                                                    <a className="btn btn-sm btn-primary"
                                                        href={process.env.REACT_APP_WEB_SERVICES_URL + "/client/download-medical-record-optional-file-1/" + work_order.work_order_id} 
                                                        target="_blank" rel="noopener noreferrer">
                                                        DOWNLOAD
                                                    </a>
                                                    
                                                </div>
                                            </div>
                                           
                                        }

                                        {(work_order?.medical_record_optional_file_2) &&


                                            <div className="col-xl-6 col-lg-6 col-sm-12">
                                                <div className="input-group ">
                                                    <a className="btn btn-sm btn-primary"
                                                        href={process.env.REACT_APP_WEB_SERVICES_URL + "/client/download-medical-record-optional-file-2/" + work_order.work_order_id} 
                                                        target="_blank" rel="noopener noreferrer">
                                                        DOWNLOAD
                                                    </a>
                                                  
                                                </div>
                                            </div>
                                           

                                        }




                                    </div>
</>
}

                       </>
                        :
                       <div className="row " >

                       <div className="col-xl-12 col-lg-12 py-4 px-5" >
                       
                          <h5>Medical record has not been uploaded yet.</h5>
                       
                       </div>
                       
                       </div>
                        }
                    
                </>
            }



        </>

    )

}
export default UploadRecord;